import { useMutation } from 'react-query';
import { message } from 'antd';
import request from '../../../../helpers/request';

export const deleteRegistrationCodes = {
  success: 0,
  hasAcceptanceResult: 1,
  hasTimePasssed: 2,
};

const mutationFn = (intervalId) =>
  request.delete(
    'Acceptance/clear_interval',
    { intervalId },
    'Не удалось удалить запись',
    'Error'
  );

export const useDeleteRegistration = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error') {
        if (!data.success) {
          message.error(data.message || 'Не удалось удалить запись');
          return;
        }

        if (options?.onSuccess) {
          options.onSuccess(data, variables);
        }
      }
    },
  });
